import { JsonProperty, Serializable } from "typescript-json-serializer";
@Serializable()
export class MediaDto {
    @JsonProperty()
    id: number;

    @JsonProperty()
    clazz: string;
        
    @JsonProperty()
    modifiedDate: number;
        
    @JsonProperty()
    modifiedBy: string;
        
    @JsonProperty()
    type: string;
        
    @JsonProperty()
    name: string;
        
    @JsonProperty()
    format: string;
        
    @JsonProperty()
    sortOrder: number;
        
    @JsonProperty()
    productId: number;
        
    @JsonProperty()
    width: number;
        
    @JsonProperty()
    height: number;
        
    @JsonProperty()
    multilingualKey: string;
  }